import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { getLangList } from '@/lib/i18n';
import {
  ScheduleOutlined,
  TeamOutlined,
  AlertOutlined,
  SolutionOutlined,
  NotificationOutlined,
  CarOutlined,
  ShoppingCartOutlined,
  LaptopOutlined,
  GiftOutlined,
  ReconciliationOutlined,
  CarryOutOutlined,
  CalendarOutlined,
  AuditOutlined,
  TableOutlined,
  LockOutlined,
  UserOutlined,
  BookOutlined,
  ContainerOutlined,
  ReadOutlined,
  DatabaseOutlined,
} from '@ant-design/icons';
import { selectDefaultMenuIndex } from "@/lib/menu";
import { setStorage, getSessionStroageEventName, getStorage } from "@/lib/webStorage";
import { hasPermission } from "@/lib/permissionUtil";

interface props {
}

interface state {
  selectedKeys: string[],
}

class MenuBar extends React.Component<props, state> {
  state = {
    selectedKeys: [],
  };
  menuTitleT: any = getLangList("menuTitle");
  unListen: any;

  componentDidMount() {
    const currentMenuIndex = getStorage("currentMenuIndex");

    this.unListen = window.addEventListener(
      getSessionStroageEventName('currentMenuIndex'),
      () => this.onClickMenu({ key: '0' })
    );

    this.setState({ selectedKeys: [currentMenuIndex] });
  }

  onClickMenu = ({ key }: any) => {
    setStorage('currentMenuIndex', key);
    this.setState({ selectedKeys: [key] });
  }

  render() {
    const { selectedKeys } = this.state;

    return (
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={selectDefaultMenuIndex()}
        onClick={this.onClickMenu}
        selectedKeys={selectedKeys}
        defaultOpenKeys={["11", "14", "21"]}
      >
        {hasPermission('SCHEDULE') &&
          <Menu.Item key="1" icon={<CalendarOutlined />}>
            <Link to="/schedule">{this.menuTitleT.schedule}</Link>
          </Menu.Item>
        }

        {hasPermission('LEAVE_SYSTEM') &&
          <Menu.Item key="2" icon={<SolutionOutlined />}>
            <Link to="/leaveSystem">{this.menuTitleT.leaveSystem}</Link>
          </Menu.Item>
        }

        {hasPermission('ROLL_CALL') &&
          <Menu.Item key="3" icon={<ScheduleOutlined />}>
            <Link to="/rollCall">{this.menuTitleT.rollCall}</Link>
          </Menu.Item>
        }

        {hasPermission('LOST_AND_FOUND') &&
          <Menu.Item key="4" icon={<AlertOutlined />}>
            <Link to="/lostAndFound">{this.menuTitleT.lostAndFound}</Link>
          </Menu.Item>
        }

        {hasPermission('RENT_OUT_FIELD') &&
          <Menu.Item key="5" icon={<ReconciliationOutlined />}>
            <Link to="./rentOutField">{this.menuTitleT.rentPlace}</Link>
          </Menu.Item>
        }

        {hasPermission('BUY_RECORD') &&
          <Menu.Item key="6" icon={<ShoppingCartOutlined />}>
            <Link to="/buyRecord">{this.menuTitleT.buyRecord}</Link>
          </Menu.Item>
        }

        {hasPermission('BUS') &&
          <Menu.Item key="7" icon={<CarOutlined />}>
            <Link to="/bus">{this.menuTitleT.bus}</Link>
          </Menu.Item>
        }

        {hasPermission('RENT') &&
          <Menu.Item key="8" icon={<LaptopOutlined />}>
            <Link to="/rent">{this.menuTitleT.rent}</Link>
          </Menu.Item>
        }

        {hasPermission('SALE') &&
          <Menu.Item key="9" icon={<GiftOutlined />}>
            <Link to="/sale">{this.menuTitleT.sale}</Link>
          </Menu.Item>
        }

        {hasPermission('ATTENDANCE') &&
          <Menu.Item key="10" icon={<CarryOutOutlined />}>
            <Link to="/attendance">{this.menuTitleT.attendance}</Link>
          </Menu.Item>
        }

        {hasPermission('TRANSCRIPT_MANAGEMENT') &&
          <Menu.Item key="20" icon={<ContainerOutlined />}>
            <Link to="/transcript">{this.menuTitleT.transcript}</Link>
          </Menu.Item>
        }

        {hasPermission('HR_MANAGEMENT') &&
          <Menu.SubMenu key="11" title={this.menuTitleT.humanResourceManagement} icon={<TeamOutlined />}>
            {hasPermission('HR_MANAGEMENT_TEACHER') &&
              <Menu.Item key="12" icon={<BookOutlined />}>
                <Link to="/teacherManagement">{this.menuTitleT.teacherManagement}</Link>
              </Menu.Item>
            }

            {hasPermission('HR_MANAGEMENT_STUDENT') &&
              <Menu.Item key="13" icon={<UserOutlined />}>
                <Link to="/studentManagement">{this.menuTitleT.studentManagement}</Link>
              </Menu.Item>
            }
          </Menu.SubMenu>
        }

        {hasPermission('ORGANIZATION') &&
          <Menu.SubMenu key="14" title={this.menuTitleT.organization} icon={<AuditOutlined />}>
            {hasPermission('ORGANIZATION_SEMESTER_MANAGEMENT') &&
              <Menu.Item key="18" icon={<DatabaseOutlined />}>
                <Link to="/semesterManagement">{this.menuTitleT.semesterManagement}</Link>
              </Menu.Item>
            }

            {hasPermission('ORGANIZATION_SUBJECT_MANAGEMENT') &&
              <Menu.Item key="19" icon={<ReadOutlined />}>
                <Link to="/subjectManagement">{this.menuTitleT.subjectManagement}</Link>
              </Menu.Item>
            }

            {hasPermission('ORGANIZATION_CLASS_MANAGEMENT') &&
              <Menu.Item key="15" icon={<TableOutlined />}>
                <Link to="/classManagement">{this.menuTitleT.classManagement}</Link>
              </Menu.Item>
            }

            {hasPermission('ORGANIZATION_PERMISSION_MANAGEMENT') &&
              <Menu.Item key="16" icon={<LockOutlined />}>
                <Link to="/permissionManagement">{this.menuTitleT.permissionManagement}</Link>
              </Menu.Item>
            }
          </Menu.SubMenu>
        }

        {hasPermission('ANNOUNCEMENT') &&
          <Menu.Item key="17" icon={<NotificationOutlined />}>
            <Link to="/announcement">{this.menuTitleT.classAnnounce}</Link>
          </Menu.Item>
        }

        {hasPermission('ARCHIVED') &&
          <Menu.SubMenu key="21" title={this.menuTitleT.archived} icon={<TeamOutlined />}>
            {hasPermission('ARCHIVED_TRANSCRIPT') &&
              <Menu.Item key="22" icon={<BookOutlined />}>
                <Link to="/archivedTranscript">{this.menuTitleT.archivedTranscript}</Link>
              </Menu.Item>
            }
          </Menu.SubMenu>
        }
      </Menu>
    )
  }
}

export default MenuBar;